
export default {
  'notificationTokens': {
    name: 'attributeNotificationTokens',
    type: 'string',
  },
  'web.liveRouteLength': {
    name: 'attributeWebLiveRouteLength',
    type: 'number',
  },
  'web.selectZoom': {
    name: 'attributeWebSelectZoom',
    type: 'number',
  },
  'web.maxZoom': {
    name: 'attributeWebMaxZoom',
    type: 'number',
  },
  'ui.disableReport': {
    name: 'attributeUiDisableReport',
    type: 'boolean',
  },
  'ui.disableEvents': {
    name: 'attributeUiDisableEvents',
    type: 'boolean',
  },
  'ui.disableVehicleFetures': {
    name: 'attributeUiDisableDeviceFetures',
    type: 'boolean',
  },
  'ui.disableDrivers': {
    name: 'attributeUiDisableDrivers',
    type: 'boolean',
  },
  'ui.disableComputedAttributes': {
    name: 'attributeUiDisableComputedAttributes',
    type: 'boolean',
  },
  'ui.disableCalendars': {
    name: 'attributeUiDisableCalendars',
    type: 'boolean',
  },
  'ui.disableMaintenance': {
    name: 'attributeUiDisableMaintenance',
    type: 'boolean',
  },
  'ui.hidePositionAttributes': {
    name: 'attributeUiHidePositionAttributes',
    type: 'string',
  },
  'distanceUnit': {
    name: 'settingsDistanceUnit',
    type: 'string',
  },
  'speedUnit': {
    name: 'settingsSpeedUnit',
    type: 'string',
  },
  'volumeUnit': {
    name: 'settingsVolumeUnit',
    type: 'string',
  },
  'timezone': {
    name: 'sharedTimezone',
    type: 'string',
  },
  // 'enableAddDevice': {
  //   name: t('enableAddDevice'),
  //   type: 'boolean',
  // },
};
